import moment from 'moment';

export const APP_VERSION = '4.13.15';

export const PSEUDO_INTEGRATIONS = ['ai', 'mcp'] as const;

export const FISCAL_MONTH = [
    {key: 'January31', id: '31.01'},
    {key: 'February28', id: '28.02'},
    {key: 'March31', id: '31.03'},
    {key: 'April30', id: '30.04'},
    {key: 'May31', id: '31.05'},
    {key: 'June30', id: '30.06'},
    {key: 'July31', id: '31.07'},
    {key: 'August31', id: '31.08'},
    {key: 'September30', id: '30.09'},
    {key: 'October31', id: '31.10'},
    {key: 'November30', id: '30.11'},
    {key: 'December31', id: '31.12'}
];
export const INTEGRATION_IMG = {
    sevdesk: {url: './assets/images/integrations/sevdesk.png', width: 100, height: 27.5},
    billomat: {url: './assets/images/integrations/billomat.png', width: 100, height: 23},
    lexware: {url: './assets/images/integrations/lexware.png', width: 138, height: 20},
    easybill: {url: './assets/images/integrations/easybill.png', width: 98, height: 32.5},
    weclapp: {url: './assets/images/integrations/weclapp.png', width: 99, height: 30.4},
    fastbill: {url: './assets/images/integrations/fastbill.svg', width: 100, height: 19},
    moco: {url: './assets/images/integrations/moco.png', width: 100, height: 25},
    publicapi: {url: './assets/images/integrations/commitly.png', width: 157, height: 41},
    zapier: {url: './assets/images/integrations/zapier.svg', width: 120, height: 55},
    make: {url: './assets/images/integrations/make.svg', width: 130, height: 45},
    alasco: {url: './assets/images/integrations/alasco.png', width: 127, height: 20},
    getmyinvoices: {
        url: './assets/images/integrations/getmyinvoices.png',
        width: 157,
        height: 21
    },
    buchhaltungsbutler: {
        url: './assets/images/integrations/buchhaltungsbutler.svg',
        width: 187,
        height: 41
    },
    pleo: {url: './assets/images/integrations/pleo.png', width: 144, height: 80},
    pleov2: {url: './assets/images/integrations/pleo.png', width: 144, height: 80, title: 'Pleo'},
    AmEx: {url: './assets/images/integrations/AmEx.png', width: 150, height: 85, title: 'American Express'},
    paypal: {
        url: './assets/images/integrations/PayPal.png', width: 170, height: 45,
        title: 'Setup.Integrations.PayPal.Title', connectionName: 'PayPal-Konto'
    },
    stripe: {url: './assets/images/integrations/stripe.png', width: 130, height: 62},
    shopify: {url: './assets/images/integrations/shopify.png', width: 170, height: 49},
    datev: {url: './assets/images/integrations/datev.png', width: 101, height: 100},
    datevdocument: {url: './assets/images/integrations/datev-export.png',
        title: 'Setup.Integrations.datevdocument.Name', width: 101, height: 100},
    candis: {url: './assets/images/integrations/candis.png', width: 200, height: 80},
    moss: {url: './assets/images/integrations/moss.png', width: 225, height: 54},
    zoho: {url: './assets/images/integrations/zoho.png', width: 150, height: 54},
    bills: {url: './assets/images/integrations/payables.png',
        title: 'PayablesPage.Payables', width: 100, height: 80},
    banking: {url: './assets/images/integrations/banking.png', width: 135, height: 90},
    googleSheets: {url: './assets/images/integrations/google-sheets.png', width: 63, height: 85},
    msExcel: {url: './assets/images/integrations/ms-excel.png', width: 150, height: 100},
    powerBi: {url: './assets/images/integrations/power-bi.png', width: 151, height: 85},
    ai: {url: './assets/images/integrations/ai-summary.png', width: 150, height: 90, title: 'ManageAddons.AI.Title'},
    mcp: {url: './assets/images/integrations/commitly.png', width: 157, height: 41, title: 'ManageAddons.MCP.Title'},
    agenda: {url: './assets/images/integrations/agenda.svg', width: 150, height: 34.5}
};

export const IntegrationCardName = {
    DATEV_EXPORTER_INTEGRATION: 'Setup.Integrations.datevdocument.Title',
    'lexware': 'Setup.Integrations.lexware.Title',
    'ai': 'ManageAddons.AI.Title',
    default: 'Setup.Integrations.ExternalServices.Title3',
};

export const IntegrationSetupCardName = {
    'candis': 'Setup.Integrations.ExternalServices.TitleUploader',
    'datev': 'Setup.Integrations.ExternalServices.TitleUploader',
    'agenda': 'Setup.Integrations.ExternalServices.TitleUploader',
    'lexware': 'Setup.Integrations.lexware.Title',
    'ai': 'ManageAddons.AI.Title',
    'mcp': 'ManageAddons.MCP.Title',
    default: 'Setup.Integrations.ExternalServices.Title3',
};

export const IntegrationSyncName = {
    'lexware': 'Lexware',
    'ai': 'ManageAddons.AI.Title',
    'Setup.Integrations.PayPal.Title': 'PayPal'
};

export const IntegrationLoadName = {
    'banking': 'AR.LoadBanking',
    default: 'AR.LoadService'
};

export const INTEGRATION_DOMAIN = {
    moco: '.mocoapp.com',
    weclapp: '.weclapp.com',
    shopify: '.myshopify.com'
}

export const INTEGRATION_PROMO = {
    payables_banner: {url: './assets/images/integrations/payables.png', width: 110}
}

export const INTEGRATION_GROUPED_DOC = {
    alasco: [
        {group: 'InvoiceGroup', items: [
            {checked: true, name: 'Invoice', true_name: 'invoice'}
        ]}
    ],
    billomat: [
        {group: 'InvoiceGroup', items: [
            {checked: true, name: 'Invoice', true_name: 'invoice'},
            {checked: true, name: 'Purchase Invoice', true_name: 'purchase'},
            {checked: true, name: 'Credit Note', true_name: 'credit'}
        ]},
        {group: 'ContractGroupShort', items: [
            {checked: false, name: 'Recurring invoice', true_name: 'recurring_invoice', target: 'contract'}
        ]}
    ],
    easybill: [
        {group: 'InvoiceGroup', items: [
            {checked: true, name: 'Invoice', true_name: 'invoice'},
            {checked: true, name: 'Charge', true_name: 'charge'},
            {checked: true, name: 'Credit Note', true_name: 'credit'}
        ]},
        {group: 'BudgetGroup', items: [
            {checked: false, name: 'Offer', true_name: 'offer'},
            {checked: false, name: 'Order', true_name: 'order'}
        ]},
        {group: 'ContractGroup', items: [
            {checked: false, name: 'Recurring document', true_name: 'recurring', target: 'contract'}
        ]}
    ],
    fastbill: [
        {group: 'InvoiceGroup', items: [
            {checked: true, name: 'Invoice', true_name: 'invoice'},
            {checked: true, name: 'Expenditure', true_name: 'expense'}
        ]}
    ],
    getmyinvoices: [
        {group: 'InvoiceGroup', items: [
            {checked: true, name: 'Sales Invoice', true_name: 'sales_invoice'},
            {checked: true, name: 'Incoming Invoice', true_name: 'invoice'},
            {checked: true, name: 'Credit Note', true_name: 'credit'},
            {checked: false, name: 'Expense reimbursement', true_name: 'expense_reimbursement'},
            {checked: false, name: 'Travel expenses', true_name: 'travel_expenses'}
        ]}
    ],
    buchhaltungsbutler: [
        {group: 'InvoiceGroup', items: [
            {checked: true, name: 'Incoming invoice', true_name: 'invoice'},
            {checked: true, name: 'Outgoing invoice', true_name: 'credit'}
        ]}
    ],
    lexware: [
        {group: 'InvoiceGroup', items: [
            {checked: true, name: 'Invoice', true_name: 'invoice'},
            {checked: true, name: 'Voucher', true_name: 'voucher'},
            {checked: true, name: 'Credit Note', true_name: 'credit'}
        ]},
        {group: 'ContractGroupShort', items: [
            {checked: false, name: 'Recurring template', true_name: 'recurrent_template', target: 'contract'}
        ]},
        {group: 'QuotationGroup', items: [
            {checked: false, name: 'Quotation', true_name: 'quotation'}
        ]}
    ],
    moco: [
        {group: 'InvoiceGroup', items: [
            {checked: true, name: 'Invoice', true_name: 'invoice'},
            {checked: true, name: 'Expenditure', true_name: 'expense'}
        ]}
    ],
    sevdesk: [
        {group: 'InvoiceGroup', items: [
            {checked: true, name: 'Invoice', true_name: 'invoice'},
            {checked: true, name: 'Voucher', true_name: 'voucher'},
            {checked: true, name: 'Credit Note', true_name: 'credit'}
        ]},
        {group: 'ContractGroupShort', items: [
            {checked: false, name: 'Recurring invoice', true_name: 'recurring_invoice', target: 'contract'}
        ]},
        {group: 'OrderGroup', items: [
            {checked: false, name: 'Proposal', true_name: 'orders_an'},
            {checked: false, name: 'Order confirmation', true_name: 'orders_ab'}
        ]}
    ],
    weclapp: [
        {group: 'InvoiceGroup', items: [
            {checked: true, name: 'Sales Invoice', true_name: 'sales_invoice', target: 'invoice'},
            {checked: true, name: 'Purchase Invoice', true_name: 'purchase'},
            {checked: true, name: 'Sales Credit Note', true_name: 'sales_invoice_credit'},
            {checked: true, name: 'Purchase Credit Note', true_name: 'purchase_credit'}
        ]},
        {group: 'BudgetGroup', items: [
            {
                checked: false,
                name: 'Purchase Order',
                true_name: 'purchase_order',
                target: 'budget',
                statuses: [
                    { name: 'Closed', value: 'CLOSED', checked: false},
                    { name: 'OrderDocumentsPrinted', value: 'ORDER_DOCUMENTS_PRINTED', checked: false},
                    { name: 'OrderEntryCompleted', value: 'ORDER_ENTRY_COMPLETED', checked: false},
                    { name: 'OrderEntryInProgress', value: 'ORDER_ENTRY_IN_PROGRESS', checked: false},
                    { name: 'Confirmed', value: 'CONFIRMED', checked: false},
                ]
            },
            {
                checked: false,
                name: 'Sales order',
                true_name: 'sales_order',
                statuses: [
                    { name: 'Closed', value: 'CLOSED', checked: false},
                    { name: 'ManuallyClosed', value: 'MANUALLY_CLOSED', checked: false},
                    { name: 'OrderConfirmationPrinted', value: 'ORDER_CONFIRMATION_PRINTED', checked: false},
                    { name: 'OrderEntryInProgress', value: 'ORDER_ENTRY_IN_PROGRESS', checked: false}
                ]
            },
        ]},
        {group: 'ContractGroup', items: [
            {checked: false, name: 'Contract', true_name: 'contract', target: 'contract'}
        ]}
    ],
    publicapi: [],
    zapier: [],
    make: [],
    pleo: [
        {group: 'TransactionGroup', items: [
            {checked: true, name: 'Expense', true_name: 'Expense'}
        ]}
    ],
    pleov2: [
        {group: 'TransactionGroup', items: [
            {checked: true, name: 'Expense', true_name: 'Expense'}
        ]}
    ],
    AmEx: [
        {group: 'TransactionGroup', items: [
            {checked: true, name: 'Transactions', true_name: 'Transactions',  show_group_name: 'TransactionGroup'}
        ]}
    ],
    paypal: [
        {group: 'TransactionGroup', items: [
            {checked: true, name: 'Transactions', true_name: 'Transactions',  show_group_name: 'TransactionGroup'}
        ]}
    ],
    stripe: [
        {group: 'TransactionGroup', items: [
            {
                checked: true,
                name: 'Customer Payment',
                true_name: 'payment',
                target: 'transaction',
                show_group_name: 'TransactionGroup'
            },
            {checked: true, name: 'Charge', true_name: 'charge', target: 'transaction'},
            {checked: true, name: 'Payout', true_name: 'payout', target: 'transaction'},
            {checked: true, name: 'Refund', true_name: 'refund', target: 'transaction'}
        ]},
        {group: 'InvoiceGroup', items: [
            {checked: false, name: 'Invoice', true_name: 'invoice', target: 'invoice'},
            {checked: false, name: 'Credit note', true_name: 'credit_note', target: 'invoice'}
        ]},
        {group: 'ContractGroup', items: [
            {checked: false, name: 'Subscription', true_name: 'subscription', target: 'contract'}
        ]}
    ],
    shopify: [
        {group: 'TransactionGroup', items: [
            {checked: true, name: 'Transaction', true_name: 'transaction', target: 'transaction'},
            {checked: true, name: 'Payout', true_name: 'payout', target: 'transaction'}
        ]}
    ],
    datev: [],
    candis: [],
    moss: [],
    zoho: [
        {group: 'InvoiceGroup', items: [
            {checked: true, name: 'Invoice', true_name: 'invoice'},
            {checked: true, name: 'Bill', true_name: 'bills'},
            {checked: true, name: 'Credit Note', true_name: 'credit'},
            {checked: true, name: 'Vendor credit', true_name: 'vendor'}
        ]}
    ],
    bills: [],
    datevdocument: [],
    agenda: []
};

export const EXCLUDE_INTEGRATION_DOC = {
    alasco: [],
    billomat: [],
    easybill: [],
    fastbill: [],
    getmyinvoices: [],
    buchhaltungsbutler: [],
    lexware: [],
    moco: [],
    sevdesk: [],
    weclapp: [],
    publicapi: [],
    zapier: [],
    make: [],
    pleo: [],
    pleov2: [],
    AmEx: [],
    paypal: [],
    stripe: [],
    shopify: [],
    datev: [],
    candis: [],
    datevdocument: [],
    agenda: []
};

export const DISPLAY_EMPTY_DATES = ['sevdesk', 'shopify', 'pleo', 'pleov2', 'paypal', 'stripe', 'zoho', 'buchhaltungsbutler', 'getmyinvoices', 'alasco', 'moco', 'fastbill', 'weclapp', 'easybill', 'lexware', 'billomat']

export const MossBankName = 'Moss';

export const TRANSACTION_INTEGRATIONS = ['pleo', 'pleov2', 'paypal', 'moss'];
export const PUBLIC_API_INTEGRATIONS = ['zapier', 'make'];
export const BANKING_INTEGRATIONS = ['banking'];
export const UPLOAD_INTEGRATIONS = ['datev', 'candis', 'moss', 'agenda', 'googleSheets', 'msExcel'];
export const BY_TARGET_INTEGRATIONS = ['stripe', 'shopify'];
export const BY_STATUS_TRANSACTION_INTEGRATIONS = [{ name: 'banking', status: 'COMPLETED'}];
export const CONTRACTS_INTEGRATIONS = ['shopify', 'weclapp', 'billomat', 'lexware', 'sevdesk'];
export const MULTIPLE_INVOICE_INTEGRATIONS = ['getmyinvoices', 'fastbill', 'moco'];
export const MULTIPLE_TRX_INTEGRATIONS = ['stripe', 'paypal', 'shopify'];
export const BILLS_INTEGRATION = 'bills';
export const RECEIVABLES_INTEGRATION = 'receivables';
export const MONITE_INTEGRATIONS = [BILLS_INTEGRATION];
export const SHEETS_INTEGRATIONS = [
    {name: 'googleSheets', title: 'Google Sheets', url: 'https://workspace.google.com/u/0/marketplace/app/commitly/505926384946?flow_type=2'},
    {name: 'msExcel', title: 'Microsoft Excel', url: 'https://appsource.microsoft.com/en-us/product/office/WA200008462?tab=Overview'}
];
export const INTEGRATION_CURRENCIES = [
    {paypal: ['EUR', 'USD', 'CHF', 'GBP', 'AUD', 'CAD', 'CNY', 'CZK', 'DKK', 'HUF', 'JPY', 'MXN', 'NOK', 'NZD', 'PLN', 'SEK', 'SGD']},
    {stripe: ['EUR', 'USD', 'CHF', 'GBP', 'AED', 'AUD', 'BGN', 'CAD', 'CNY', 'CZK', 'DKK', 'HUF', 'JPY', 'MXN', 'NOK', 'NZD', 'PLN', 'RON', 'SEK', 'SGD', 'TRY']},
    {shopify: ['EUR', 'USD', 'CHF', 'GBP', 'CZK', 'DKK', 'RON', 'SEK']},
];
export const DATEV_EXPORTER_INTEGRATION = 'datevdocument';

export const ZAPIER_LINK = 'https://zapier.com/developer/public-invite/146407/159bc4cfd0df4fce44d59563891e2192/';
export const MAKE_LINK = 'https://www.make.com/en/hq/app-invitation/ff9a2ac6fe456c8f8092b4b691d284c8';

/**
 * Countries a company/group may be based in — lowercase ISO alpha-2, matching the API's `country`
 * value. Labels come from CountriesService.getCompanyCountries(); `OTHER_COUNTRY_ID` has no ISO
 * code and keeps its own translation.
 */
export const COMPANY_COUNTRY_IDS = ['de', 'at', 'ba', 'be', 'bg', 'hr', 'cy', 'cz', 'dk', 'ee', 'fi',
    'fr', 'gr', 'hu', 'is', 'ie', 'it', 'lv', 'li', 'lt', 'lu', 'mt', 'nl', 'no', 'pl', 'pt', 'ro',
    'sk', 'si', 'es', 'se', 'ch', 'gb'];

/** Main markets — pinned to the top of the picker. */
export const PINNED_COMPANY_COUNTRY_IDS = ['de', 'at'];

export const OTHER_COUNTRY_ID = 'o';

/**
 * Countries each bank-connection provider operates in — lowercase ISO alpha-2, the same domain as
 * COMPANY_COUNTRY_IDS. A provider is offered only where the company's country is listed here;
 * subscription permissions and feature flags still gate it on top.
 */
export const FINAPI_COUNTRY_IDS = ['de', 'at'];
export const BANKSAPI_COUNTRY_IDS = ['de', 'at'];
export const EBICS_COUNTRY_IDS = ['de', 'at', 'ch'];

/**
 * GoCardless's full coverage — every company country except Switzerland. Drives the in-wizard
 * country filter, where cross-border picks are allowed.
 */
export const GOCARDLESS_COUNTRY_IDS = ['de', 'at', 'be', 'bg', 'hr', 'cy', 'cz', 'dk', 'ee', 'fi',
    'fr', 'gr', 'hu', 'is', 'ie', 'it', 'lv', 'li', 'lt', 'lu', 'mt', 'nl', 'no', 'pl', 'pt', 'ro',
    'sk', 'si', 'es', 'se', 'gb'];

/**
 * Where the GoCardless connection type is offered: its coverage minus Austria, which finAPI,
 * BANKSapi and EBICS serve instead. Germany keeps it (needed for Pleo connections). Narrower than
 * GOCARDLESS_COUNTRY_IDS on purpose — a company outside DE/AT may still pick an Austrian bank in
 * the country filter.
 */
export const GOCARDLESS_COMPANY_COUNTRY_IDS = GOCARDLESS_COUNTRY_IDS.filter((id) => id !== 'at');

export enum InvoiceStatus {
    Paid = 3,
    Order = 9,
    Expected = 2,
    Promised = 6,
    OnHold = 5,
    PartiallyPaid = 4,
    Installments = 10,
    Overdue = 1,
    Dispute = 7,
    Cancel = 8,
    InProgress = 11
}

export enum InvoiceStatusKey {
    Paid = 'PD',
    Order = 'OR',
    Expected = 'PL',
    Promised = 'PR',
    OnHold = 'HD',
    PartiallyPaid = 'PP',
    Installments = 'IN',
    Overdue = 'OD',
    Dispute = 'DP',
    Cancel = 'CA',
    InProgress = 'IP'
}

export const STATUS = [
    {title: 'ExpectedTransactions.Statuses.Paid', shortKey: InvoiceStatusKey.Paid, id: InvoiceStatus.Paid},
    {title: 'ExpectedTransactions.Statuses.Order', shortKey: InvoiceStatusKey.Order, id: InvoiceStatus.Order},
    {title: 'ExpectedTransactions.Statuses.Expected', shortKey:InvoiceStatusKey.Expected, id: InvoiceStatus.Expected}, //{title: 'ExpectedTransactions.Statuses.Planned', shortKey: 'PL', id: 2},
    {title: 'ExpectedTransactions.Statuses.Promised', shortKey: InvoiceStatusKey.Promised, id: InvoiceStatus.Promised},
    {title: 'ExpectedTransactions.Statuses.OnHold', shortKey: InvoiceStatusKey.OnHold, id: InvoiceStatus.OnHold},
    {title: 'ExpectedTransactions.Statuses.PartiallyPaid', shortKey: InvoiceStatusKey.PartiallyPaid, id: InvoiceStatus.PartiallyPaid},
    {title: 'ExpectedTransactions.Statuses.Installments', shortKey: InvoiceStatusKey.Installments, id: InvoiceStatus.Installments},
    {title: 'ExpectedTransactions.Statuses.Overdue', shortKey: InvoiceStatusKey.Overdue, id: InvoiceStatus.Overdue},
    {title: 'ExpectedTransactions.Statuses.Dispute', shortKey: InvoiceStatusKey.Dispute, id: InvoiceStatus.Dispute},
    {title: 'ExpectedTransactions.Statuses.Cancel', shortKey: InvoiceStatusKey.Cancel, id: InvoiceStatus.Cancel},
    {title: 'ExpectedTransactions.Statuses.InProgress', shortKey: InvoiceStatusKey.InProgress, id: InvoiceStatus.InProgress}
];
export const ERRORNAMES = [
    'ExpectedTransactions.NoTransactions',
    'ExpectedTransactions.NoTransactionsReceivables',
    'ExpectedTransactions.NoTransactionsPayables',
    'ExpectedTransactions.NoTransactionsPaid',
    'ExpectedTransactions.NoTransactionsMatched',
    'ExpectedTransactions.NoTransactionsCanceled'
];
export const TYPE = [
    {key: 'ArchitekturBauwesen', id: 'ArchitekturB'},
    {key: 'AutomobilFahrzeugbau', id: 'AutomobilFah'},
    {key: 'BankenFinanzdienstleistungen', id: 'BankenFinanz'},
    {key: 'BeratungConsulting', id: 'BeratungCons'},
    {key: 'EnergieWasserUmwelt', id: 'EnergieWasse'},
    {key: 'ErziehungBildungWissenschaft', id: 'ErziehungBil'},
    {key: 'GesundheitSoziales', id: 'GesundheitSo'},
    {key: 'Immobilien', id: 'Immobilien'},
    {key: 'IndustrieMaschinenbau', id: 'IndustrieMas'},
    {key: 'InternetInformationstechnologie', id: 'InternetInfo'},
    {key: 'KonsumgueterHandel', id: 'KonsumgueterH'},
    {key: 'KunstKulturSport', id: 'KunstKulturS'},
    {key: 'LandForst', id: 'LandForst'},
    {key: 'MarketingPRDesign', id: 'MarketingPRD'},
    {key: 'MedienVerlage', id: 'MedienVerlag'},
    {key: 'OeffentlicherDienstVerbaendeEinrichtungen', id: 'Oeffentlicher'},
    {key: 'Personaldienstleistungen', id: 'Personaldien'},
    {key: 'PharmaMedizintechnik', id: 'PharmaMedizi'},
    {key: 'Telekommunikation', id: 'Telekommunik'},
    {key: 'TourismusGastronomie', id: 'TourismusGas'},
    {key: 'TransportLogistik', id: 'TransportLog'},
    {key: 'Versicherungen', id: 'Versicherung'},
    {key: 'WirtschaftspruefungSteuernRecht', id: 'Wirtschaftsp'}
];
export const DATE_CLEAN_REGEX = /[^a-zA-Z0-9,\s]/g;
export enum UploadSheetSlug {
    invoices = 'invoices',
    transactions = 'transactions',
    budgets = 'budgets',
    split = 'split',
    moss = 'moss',
    datev = 'datev',
    candis = 'candis',
    agenda = 'agenda'
}

export const IGNORE_DATEV_COLUMNS = ['KZN', 'Tage', 'Haben', 'Soll', 'Eingabebetrag', 'Wkz', 'Beleg-Nr.', 'BL', 'Betrag Soll', 'Betrag Haben', 'R', 'Ausgl.', 'fallig', 'Belegfeld 2', 'Kz', 'USt%', 'UST%', 'Stapel-Nr.', 'BSNr.', 'ZI', 'GP-Bank', 'Div. Adresse', 'Mdt-Bank', 'SEPA-Mandatsreferenz', 'Zahlungskondition', 'Sachverhalt', 'Zinssperre', 'Kreditlimit', 'Stra?e', 'Strasse', 'PLZ', 'Ort', 'Land', 'Unternehmensgegenstand', 'Kunden-/Lief.-Nr.', 'Nummer Fremdsystem', 'Kurzbezeichnung', 'Telefon'];

export const IGNORE_CANDIS_COLUMNS = ['o', 'Belegtyp', 'IBAN', 'Leistungsdatum', 'Kreditoren-Kontonummer', 'WC$hrung', 'Steuer %', 'KOST2', 'BU-SchlC<ssel', 'Notiz', 'Status', 'Anforderer', 'Aktuelle Freigeber', 'Bisherige Freigeber', 'Erstellt am', 'Unternehmen-ID']

export const IGNORE_MOSS_COLUMNS = ['Fälligkeit', 'ID'];

export const IGNORE_AGENDA_COLUMNS = ['Beleg2', 'M-Datum', 'MK', 'Belegsaldo', 'Auszifferungsnummer'];

export enum RULES_CONDITIONS {
    AND = 'all',
    OR = 'any',
    PRE_MAP = 'pre-map',
    MAP = 'map',
    EXCLUDE = 'exclude',
    contains = 'contains',
    contains_exact = 'contains_exact',
    eq = 'eq',
    lt = 'lt',
    gt = 'gt',
    not_contains = 'not_contains',
    fk = 'fk',
    source = 'source',
    external_source = 'external_source',
    tags = 'tags',
    exact = 'exact',
    counterpart_iban = 'counterpart_iban'
}

export enum RULES_CONDITION_FILED_TYPE {
    ACCOUNT,
    INTEGRATION,
    TAGS,
    STRING,
    NUMBER
}

export const RuleConditionType: any = {
    [RULES_CONDITIONS.AND]: RULES_CONDITION_FILED_TYPE.STRING,
    [RULES_CONDITIONS.OR]: RULES_CONDITION_FILED_TYPE.STRING,
    [RULES_CONDITIONS.PRE_MAP]: RULES_CONDITION_FILED_TYPE.STRING,
    [RULES_CONDITIONS.MAP]: RULES_CONDITION_FILED_TYPE.STRING,
    [RULES_CONDITIONS.EXCLUDE]: RULES_CONDITION_FILED_TYPE.STRING,
    [RULES_CONDITIONS.contains]: RULES_CONDITION_FILED_TYPE.STRING,
    [RULES_CONDITIONS.contains_exact]: RULES_CONDITION_FILED_TYPE.STRING,
    [RULES_CONDITIONS.eq]: RULES_CONDITION_FILED_TYPE.NUMBER,
    [RULES_CONDITIONS.lt]: RULES_CONDITION_FILED_TYPE.NUMBER,
    [RULES_CONDITIONS.gt]: RULES_CONDITION_FILED_TYPE.NUMBER,
    [RULES_CONDITIONS.not_contains]: RULES_CONDITION_FILED_TYPE.STRING,
    [RULES_CONDITIONS.fk]: RULES_CONDITION_FILED_TYPE.ACCOUNT,
    [RULES_CONDITIONS.source]: RULES_CONDITION_FILED_TYPE.INTEGRATION,
    [RULES_CONDITIONS.external_source]: RULES_CONDITION_FILED_TYPE.INTEGRATION,
    [RULES_CONDITIONS.tags]: RULES_CONDITION_FILED_TYPE.TAGS,
    [RULES_CONDITIONS.exact]: RULES_CONDITION_FILED_TYPE.STRING,
    [RULES_CONDITIONS.counterpart_iban]: RULES_CONDITION_FILED_TYPE.STRING
}

export enum InvoiceType {
    Receivable = 'RE',
    Payable = 'PA'
}

export enum CommonTransactionType {
    Transaction = 'ACT',
    Invoice = 'INV',
    Budget = 'BUD'
}

export const MY_FORMATS = {
    parse: {
        dateInput: 'LL',
    },
    display: {
        dateInput: 'D MMM YY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

export const Currencies = [
    {title: 'EUR'},
    {title: 'USD'},
    {title: 'CHF'},
    {title: 'GBP'},
    {title: 'AED'},
    {title: 'AUD'},
    {title: 'BAM'},
    {title: 'BGN'},
    {title: 'CAD'},
    {title: 'CNY'},
    {title: 'CZK'},
    {title: 'DKK'},
    {title: 'HRK'},
    {title: 'HUF'},
    {title: 'JPY'},
    {title: 'MXN'},
    {title: 'NOK'},
    {title: 'NZD'},
    {title: 'PLN'},
    {title: 'RON'},
    {title: 'SEK'},
    {title: 'SGD'},
    {title: 'TRY'}
]

export const DATE_PRESETS_PREV = [
    {
        title: 'Last7Days',
        value: [moment().subtract(6, 'days'), moment()]
    },
    {
        title: 'ThisMonth',
        value: [moment().startOf('month'), moment().endOf('month')]
    },
    {
        title: 'LastMonth',
        value: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
    },
    {
        title: 'ThisQuarter',
        value: [moment().startOf('quarter'), moment().endOf('quarter')]
    },
    {
        title: 'LastQuarter',
        value: [moment().subtract(1, 'Q').startOf('quarter'), moment().subtract(1, 'Q').endOf('quarter')]
    },
    {
        title: 'YearToDay',
        value: [moment().startOf('year'), moment()]
    },
    {
        title: 'ThisYear',
        value: [moment().startOf('year'), moment().endOf('year')]
    }
]

export const DATE_PRESETS_NEXT = [
    {
        title: 'Next7Days',
        value: [moment(), moment().add(6, 'days')]
    },
    {
        title: 'NextMonth',
        value: [
            moment().add(1, 'month').startOf('month'),
            moment().add(1, 'month').endOf('month')
        ]
    },
    {
        title: 'NextQuarter',
        value: [
            moment().add(1, 'quarter').startOf('quarter'),
            moment().add(1, 'quarter').endOf('quarter')
        ]
    },
    {
        title: 'NextYear',
        value: [
            moment().add(1, 'year').startOf('year'),
            moment().add(1, 'year').endOf('year')
        ]
    }
]

export const MIN_DATE_DATEPICKER = moment().year(2010).startOf('year').toISOString();
export const MIN_DATE_DATEPICKER_UNIX = moment().year(2010).startOf('year').unix();
export const MAX_DATE_DATEPICKER = moment().year(2035).startOf('year').toISOString();
export const MAX_DATE_DATEPICKER_UNIX = moment().year(2035).startOf('year').unix();

export const MAX_YEAR_ENTITY = 5;
export const EXPIRING_FORECAST_DAYS = 180;

export const MAX_YEAR_REC_BUDGET = 10;
export const MAX_YEAR_REC_BUDGET_WEEKLY = 5;
export const MAX_YEAR_REC_BUDGET_DAILY = 1;

//flatfile
export const MAX_RECORDS = 3000;
export const MAX_PER_REQUEST = 1000;
export const MAX_FIELD_LENGTH = 255;
export const REFERENCE_MAX_LENGTH = 100;
export const TAGS_MAX_LENGTH = 200;
export const MAX_UPLOAD_DATE_YEARS_AHEAD = 5;

export const CONTRACT_SOURCE = 'manual contract';

export const DOMAINS = [
    {region: 'Europe', domain: '.eu', title: null},
    {region: 'USA', domain: '.com', title: null},
    {region: 'Australia', domain: '.com.au', title: null},
    {region: 'Japan', domain: '.jp', title: null},
    {region: 'India', domain: '.in', title: null},
    {region: 'SaudiArabia', domain: '.sa', title: null}
]

//#region comments
export enum FeedType {
    All = 'All',
    General = 'General',
    Transactions = 'Transactions',
    Invoices = 'Invoices',
    Rules = 'Rules',
    Budgets = 'Budgets',
    Contracts = 'Contracts',
    Plans = 'Plans',
    Payables = 'Payables', //bills - for monite payables
    Receivables = 'Receivables', //receivables - for monite receivables
    Counterparts = 'Counterparts',
    ApprovalPolicies = 'ApprovalPolicies',
    CardTransactions = 'CardTransactions',
    Own = 'Own',
    Other = 'Other'
}

export enum ResourceType {
    company = 'company',
    transaction = 'transaction',
    invoice = 'invoice',
    payable = 'payable', //bills - for monite payables
    budget = 'budget',
    contract = 'contract',
    loan = 'loan',
    plan = 'plan',
    general = 'general',
    plan_period = 'plan_period',
    rule = 'rule',
    user = 'user',
    counterpart = 'counterpart',
    approval_policy = 'approval_policy',
    receivable = 'receivable', //receivables - for monite receivables
    banking_transaction = 'banking_transaction' //TODO: Home page add breadcrumbs and view object
}

export enum FeedGroup {
    company = 'company',
    company_comments = 'company_comments',
    transaction = 'transaction',
    transaction_comments = 'transaction_comments',
    banking_transaction = 'banking_transaction', //common feed for view activities and comments of banking transactions
    banking_transaction_comments = 'banking_transaction_comments',//feed to view\add comments of banking transactions
    banking_transaction_activities = 'banking_transaction_activities',//feed to add activities of banking transactions
    invoice = 'invoice',
    invoice_comments = 'invoice_comments',
    budget = 'budget',
    budget_comments = 'budget_comments',
    contract = 'contract',
    contract_comments = 'contract_comments',
    loan = 'loan',
    loan_comments = 'loan_comments',
    plan = 'plan',
    plan_comments = 'plan_comments',
    plan_comments_period = 'plan_comments_period',
    tag = 'tag',
    user = 'user',
    user_comments = 'user_comments',
    notification = 'notification',
    general = 'general',
    rule = 'rule',
    rule_comments = 'rule_comments',
    company_activities = 'company_activities',
    transaction_activities = 'transaction_activities',
    user_activities = 'user_activities',
    invoice_activities = 'invoice_activities',
    budget_activities = 'budget_activities',
    contract_activities = 'contract_activities',
    loan_activities = 'loan_activities',
    rule_activities = 'rule_activities',
    plan_activities = 'plan_activities',
    plan_activities_period = 'plan_activities_period',
    company_various_activities = 'company_various_activities',
    company_various = 'company_various',
    company_various_comments = 'company_various_comments',
    bill = 'bill',
    bill_comments = 'bill_comments',
    bill_activities = 'bill_activities',
    receivable = 'receivable',
    receivable_comments = 'receivable_comments',
    receivable_activities = 'receivable_activities',
    counterpart = 'counterpart',
    counterpart_comments = 'counterpart_comments',
    counterpart_activities = 'counterpart_activities',
    approval_policy = 'approval_policy',
    approval_policy_comments = 'approval_policy_comments',
    approval_policy_activities = 'approval_policy_activities'
}

export enum FeedEntityPrefix {
    forecast = 'forecast',
    //sequence_id of reccuring budget
    sid = 'sid'
}

export enum FeedForeignPrefix {
    companyId = 'companyId',
    budgetId = 'budgetId',
    sequenceId = 'sequenceId'
}

export enum CommentsTab {
    comment = 0,
    activity = 1
}

export enum BudgetCommentsTab {
    info = 0,
    comment = 1,
    activity = 2
}

export enum ActivityVerb {
    comment = 'comment',
    activity = 'activity',
    like = 'like'
}

export enum ActionType {
    create = 'create',
    update = 'update',
    delete = 'delete'
}

export enum ActivitiesAction {
    create = 'create',
    update = 'update',
    save = 'save',
    remap = 'remap',
    delete = 'delete',
    create_bulk = 'create_bulk',
    update_bulk = 'update_bulk',
    remap_bulk = 'remap_bulk',
    delete_bulk = 'delete_bulk',
    create_split = 'create_split',
    update_split = 'update_split',
    delete_split = 'delete_split',
    match = 'match',
    unmatch = 'unmatch',
    confirm_deviation = 'confirm_deviation',
    commit = 'commit',
    activate = 'activate',
    inactivate = 'inactivate',
    pause = 'pause',
    upload = 'upload',
    remove_file = 'remove_file',
    invite_support = 'invite_support',
    delete_support = 'delete_support',
    login = 'login',
    // BE actions
    invoice_imported_from_integration = 'invoice_imported_from_integration',
    budget_add = 'budget_add',
    transaction_imported_from_integration = 'transaction_imported_from_integration',
    invoice_map_tags = 'invoice_map_tags',
    transaction_map_tags = 'transaction_map_tags',
    invoice_exclude = 'invoice_exclude',
    transaction_exclude = 'transaction_exclude',
    transaction_map_categories = 'transaction_map_categories',
    invoice_map_categories = 'invoice_map_categories',
    budget_map_categories = 'budget_map_categories',
    invoice_status_change = 'invoice_status_change',
    invoice_expected_date_change = 'invoice_expected_date_change',
    transaction_imported_from_finapi = 'transaction_imported_from_finapi',
    add_api_account = 'add_api_account',
    delete_api_account = 'delete_api_account',
    onboarding_step_done = 'onboarding_step_done',
    //monite
    submit_for_approval = 'submit_for_approval',
    submit_for_payment = 'submit_for_payment',
    approve = 'approve',
    reject = 'reject',
    pay = 'pay',
    payment_failed = 'payment_failed',
    partially_paid = 'partially_paid',
    paid = 'paid',
    export = 'export',
    exportToDatev = 'exportToDatev',
    cancel = 'cancel',
    reopen = 'reopen',
    issue = 'issue',
    mark_as_paid = 'mark_as_paid',
    generate_xml = 'generate_xml',
    upload_file = 'upload_file',
    attach_file = 'attach_file',
    cancelled_by_duplicate = 'cancelled_by_duplicate'
}

export enum ResourceArea {
    bank_account = 'bank_account',
    company = 'company',
    integration = 'integration',
    team = 'team',
    category_team = 'category_team',
    category = 'category',
    reporting = 'reporting',
    file = 'file'
}

export const COLORS_COUNT = 7;
export const SYSTEM_USER_ID = 'system';
export const SYSTEM_USER_NAME = 'Dashboard.Home.Members.System';
export const SYSTEM_USER_SHORT = '';

export const DELETED_USER_NAME = 'Dashboard.Home.Members.DeletedMemberName';
export const DELETED_USER_SHORT = 'Dashboard.Home.Members.DeletedMemberShort';

export const DELETED_ENTITY = 'Dashboard.Home.EntityDeleted';

export const ALL_USER_ID = 'all';
export const ALL_USER_NAME = 'Dashboard.Home.Members.All';

export const MAX_TEXT_LENGTH = 512;
//#endregion

export enum StartingPage {
    Home = 'home',
    Insights = 'insights',
    Outlook = 'outlook',
    Transactions = 'transactions',
    AccountReceivables = 'account-receivables',
    Planning = 'planning'
}

//#region Monite

export const EXPORTED_TAG = 'Exported';
export const XML_TAG = 'XML';
export const DATEV_TAG = 'DATEV';
export const MANUAL_TAG = 'Manual';
export const SYSTEM_BILLS_TAGS = [DATEV_TAG, EXPORTED_TAG, XML_TAG, MANUAL_TAG, 'Duplicate'];

export enum PayableDocumentType {
    Payable = 'payable',
    CreditNote = 'credit_note'
};

export enum MonitePayableSource {
    ocr = 'ocr',
    user_specified = 'user_specified'
}
export enum PayableOrigin {
    upload = 'upload',
    email = 'email',
    einvoicing = 'einvoicing'
}
export enum MoniteOcrStatus {
    processing = 'processing',
    error = 'error',
    success = 'success',
    canceled = 'canceled'
}
export enum MoniteCounterpartsType {
    organization = 'organization',
    individual = 'individual'
}
export enum MoniteCounterpartsCategory {
    Customer = 'Customer',
    Vendor = 'Vendor',
    Both = 'Both'
}
export enum MoniteTagCategory {
    document_type = 'document_type',
    department = 'department',
    project = 'project',
    cost_center = 'cost_center',
    vendor_type = 'vendor_type',
    payment_method = 'payment_method',
    approval_status = 'approval_status'
}
export enum MoniteApprovalPolicyStatus {
    active = 'active',
    pending = 'pending'
}
export enum MoniteApprovalPolicyConditions {
    Amount = 'Amount',
    Suppliers = 'Suppliers',
    CreatedBy = 'CreatedBy',
    Tags = 'Tags'
}
export enum MoniteApprovalPolicyFlows {
    SingleUser = 'SingleUser',
    AnyUser = 'AnyUser',
    UsersOneByOne = 'UsersOneByOne'
}
export enum MoniteApprovalPolicyAmountConditions {
    Greater = 'Greater',
    GreaterOrEqual = 'GreaterOrEqual',
    Less = 'Less',
    LessOrEqual = 'LessOrEqual',
    Equal = 'Equal',
    InRange = 'InRange'
}

export const MoniteCountriesForPayment = ['AT', 'BE', 'CY', 'DE', 'EE', 'ES', 'FI', 'FR', 'GR', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PT', 'SI', 'SK'];

export const SEPA_XML_COUNTRIES = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','IS','LI','NO','AD','MC','SM','CH','GB','VA'];

export const SEPA_CURRENCY = 'EUR';

export const SUBSCRIPTION_TYPE = {
    basis: 'basis',
    pure: 'pure',
    business: 'business',
    team: 'team',
    professional: 'professional'
}

export const SUBSCRIPTION_PERIOD = {
    monthly: 'monthly',
    yearly: 'yearly',
    'every-24-months': 'every-24-months',
}

export const BILLS_ADDONS_CONFIG = {
    monthly: '2025-payables',
    yearly: '2025-payables-pa'
};

export const EBICS_ADDONS_CONFIG = {
    monthly: '2026-ebics-EUR-Monthly',
    yearly: '2026-ebics-EUR-Yearly',
    'every-24-months': '2026-ebics-EUR-Every-24-months'
};

export const APPROVAL_POLICIES_ADDONS_CONFIG = {
    monthly: '2025-approval-pm',
    yearly: '2025-approval-pa'
};

export const MCP_SERVER_ADDON_FLAG = 'mcp_server_addon';

export const MCP_ADDONS_CONFIG = {
    monthly: '2026-MCP-Server-EUR-Monthly',
    yearly: '2026-MCP-Server-EUR-Yearly',
    'every-24-months': '2026-MCP-Server-EUR-Every-24-months',
};

export const MULTI_COUNTRY_BANKS_ADDONS_CONFIG = {
    monthly: '2026-Multi-Country-Banks-EUR-Monthly',
    yearly: '2026-Multi-Country-Banks-EUR-Yearly',
    'every-24-months': '2026-Multi-Country-Banks-EUR-Every-24-months',
};

/** White logo for green promo banners; do not run through imageColorScheme (path already theme-safe). */
export const MCP_PROMO_LOGO = './assets/images/integrations-white/commitly.png';

export const MONITE_CHUNK_SIZE = 10;
export const MONITE_CHUNK_DELAY = 1000;
